export default {
  freightCollection: [],
};
